<template>
  <div class="promotionTitle">
    <h2>{{titleDisplay}}</h2>
    <div class="promotionTitle-more  JARVIS_LandingPage_FreeToPlay_Btn_SeeAll">      
        <span  @click="showLogin">{{clickDisplay}}</span>
      <svg class="svgIcon"><use xlink:href="#systemIcon_arrowRight"></use></svg>
    </div>
  </div>  
</template>


<script>
import Cookies from 'js-cookie';
import i18n from "@/lang/i18n";

export default {
  name: 'GameTitle', 
  props: {
      
  },
  mounted() {
    window.eventEmitter.on('product.updateLanguage', this.changeDisplay);
    this.changeDisplay();
  },
  data() {
    return {
      titleDisplay : 'Popular Games',
      clickDisplay : 'Login to See all',
      lang: 'en'
    };
  },
  methods: {  
    showLogin() {
      window.eventEmitter.emit('pp.showLogin', 'Games');
    },
    changeDisplay() {
      let languageType = Cookies.get('LanguageType');
      if (languageType == null || languageType == undefined)
        languageType = 'en';

      const lang = languageType.toLowerCase();
      this.lang = lang.replace('_','-');
      i18n.locale = lang;

      this.titleDisplay = i18n.t('popular_games');
      this.clickDisplay = i18n.t('login_to_see_all');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/scss/components/common/promotionTitle";
</style>
